module.exports = "<p>\r\n  user-info-dialog works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/user-info-dialog/user-info-dialog.component.html
// module id = ./src/app/component/user-info-dialog/user-info-dialog.component.html
// module chunks = main